import { Box, Button, Typography } from '@mui/material';
import { BackArrow } from 'components/BackArrow';
import { HistoryCard } from 'components/HistoryCard/HistoryCard';
import { getSleepsForPatientQuery } from 'dataLayer/sleep';
import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import useSelector from 'redux/useSelector';
import { paths } from 'routes';
import { colors } from 'theme';
import { Sleep } from 'types/types';
import ReactGA from 'react-ga';

export const SleepHistory: FunctionComponent = () => {
  const userId = useSelector(state => state.user.id);
  const navigate = useNavigate();
  const { data: sleepList, isLoading } = useQuery(getSleepsForPatientQuery(userId));

  const sleepPageWrapper = useRef<HTMLDivElement>(null);

  const [appWidth, setAppWidth] = useState(0);

  const getAppWidth = () => {
    if (sleepPageWrapper.current) setAppWidth(sleepPageWrapper?.current?.offsetWidth);
  };

  useEffect(() => {
    getAppWidth();
    window.addEventListener('resize', getAppWidth);
  }, []);

  const navigateToRecord = useCallback(() => {
    ReactGA.event({
      category: 'ButtonClick',
      action: 'Record Sleep From History Page',
    });
    navigate(paths.RECORD_SLEEP);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        mb: 6,
      }}
      ref={sleepPageWrapper}
    >
      <Box style={{ display: 'flex' }}>
        <Box style={{ flex: 1 }}>
          <BackArrow />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography
            fontFamily="Poppins Medium"
            fontSize="18px"
            style={{ color: colors.darkPurple }}
          >
            <FormattedMessage id="sleep-history.title" />
          </Typography>
        </Box>
        <Box style={{ flex: 1 }}></Box>
      </Box>
      {sleepList &&
        sleepList.map((sleep: Sleep) => (
          <HistoryCard key={sleep.id} historyType="sleep" data={sleep} />
        ))}
      <Box
        position="fixed"
        height={48}
        bottom="0px"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Button
          variant="contained"
          onClick={navigateToRecord}
          style={{
            color: colors.white,
            backgroundColor: colors.darkPurple,
            width: `${appWidth}px`,
          }}
        >
          <FormattedMessage id="sleep-history.add-sleep-record" />
        </Button>
      </Box>
    </Box>
  );
};
